import { h } from 'preact';
export default (props) => (<svg viewBox="0 0 170.2 209.2" enable-background="new 0 0 170.2 209.2" class={props.class}>
		<path d="M7.1,200.9l-2.9-6.4c0.3-0.1,30.5-13.9,61.4-43.5c18.1-17.3,32.8-36.7,43.8-57.5c12.8-24.2,20.6-50.6,23.2-78.3l-26.1,17.1
    l-3.8-5.9L138.6,3l22.4,36l-5.9,3.7l-15.6-25c-6.6,65.9-40.9,111.6-69.1,138.7C38.6,186.7,8.4,200.4,7.1,200.9z"/>
</svg>);



// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/arrowATH/index.js